import { Component, OnInit } from '@angular/core';
import { Services } from '../services/servicos';
import { TecnicaModel } from '../tecnica/tecnica-model';

@Component({
  selector: 'app-central',
  templateUrl: './central.component.html',
  styleUrls: ['./central.component.css']
})
export class CentralComponent implements OnInit {

  products: TecnicaModel[];
  loading: boolean = true;
  TotalDia: number = 0;
  AtendeNAO: number = 0;
  AtendeSIM: number = 0;

  responsiveOptions;

  constructor(private service: Services) {
    this.responsiveOptions = [
      {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
      },
      {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
      }
    ];
  }

  ngOnInit() {
    this.Listar();
    this.startTimer();  
  }

  timeLeft: number = 30;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 30;
        // console.log('Atualizou');
        this.Listar();
      }
      // console.log(this.timeLeft);
    }, 1000)
  }

  Listar(){
    this.loading = true;
    try {
      this.service.listarChamadaTecnica()
        .subscribe(data => {
          if (data.Success) {
            this.products = data.Response;
            if (data.Response.length > 0) {
              this.AtendeNAO = data.Response[0].AtendeNAO;
            } else {
              this.AtendeNAO = 0;
            }
            this.loading = false;
          }
        },
          err => console.error(err)
        );
        
    }
    catch (e) {
      alert(e);
    }
  }
}

